import React from 'react';

const DependencyOut = ({
  color,
  height,
  width,
}: {
  color?: string;
  height?: number;
  width?: number;
}) => {
  return (
    <svg
      width={width ?? 20}
      height={height ?? 20}
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.24362 4.16667L4.24362 6.91294L6.98989 6.91294L6.98989 4.16667L4.24362 4.16667ZM3.82695 2.5C3.13659 2.5 2.57695 3.05964 2.57695 3.75L2.57695 7.32961C2.57695 8.01996 3.13659 8.57961 3.82695 8.57961L7.03716 8.57961L7.03716 11.7898C7.03716 12.4802 7.5968 13.0398 8.28716 13.0398L11.4973 13.0398V16.25C11.4973 16.9404 12.057 17.5 12.7473 17.5H16.327C17.0173 17.5 17.577 16.9404 17.577 16.25V12.6704C17.577 11.98 17.0173 11.4204 16.327 11.4204H13.1168L13.1168 8.2102C13.1168 7.51984 12.5571 6.9602 11.8668 6.9602L8.65656 6.9602L8.65656 3.75C8.65656 3.05964 8.09691 2.5 7.40656 2.5L3.82695 2.5ZM8.70382 8.62686L8.70382 11.3731L11.4501 11.3731L11.4501 8.62686L8.70382 8.62686ZM13.164 15.8333V13.0871H15.9103V15.8333H13.164Z"
        fill={color ? color : '#6E6B8C'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.50831 12.4605C2.18287 12.7859 2.18287 13.3136 2.50831 13.639L3.72752 14.8582L2.50831 16.0774C2.18287 16.4028 2.18287 16.9305 2.50831 17.2559C2.83375 17.5814 3.36138 17.5814 3.68682 17.2559L5.49529 15.4475C5.65157 15.2912 5.73936 15.0792 5.73936 14.8582C5.73936 14.6372 5.65157 14.4252 5.49529 14.2689L3.68682 12.4605C3.36138 12.135 2.83375 12.135 2.50831 12.4605Z"
        fill={color ? color : '#6E6B8C'}
      />
    </svg>
  );
};

export default DependencyOut;
